import { render } from "./ImpersonationAlert.vue?vue&type=template&id=fd4b807e&scoped=true"
import script from "./ImpersonationAlert.vue?vue&type=script&lang=js"
export * from "./ImpersonationAlert.vue?vue&type=script&lang=js"

import "./ImpersonationAlert.vue?vue&type=style&index=0&id=fd4b807e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4b807e"]])

export default __exports__